import { FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { getCTAClassNames } from '../helpers';
import styles from './CallToAction.module.less';

/**
 * A component that is style to look like a button but includes
 * validation to require use of either Anchor element or Link component
 *
 * @example
 * ```jsx
 * <CallToAction text="Click for more" to="/">
 * </CallToAction>
 * ```
 * @param {string} text call to action text
 * @param {string} href link destination using an Anchor element - will throw errors if neither href and Link are used or if both are used
 * @param {string} to link destination using react-router's Link component
 * @param {string} target target attribute representing where to open the document Typically: '_blank', '_self', '_parent', '_top'
 * @param {string} color one of the following predefined colors: ['ocean', 'navy', 'yellow'], defaults to ocean if level is primary, navy if level is secondary, and to neutral gray if neither are provided
 * @param {string|node} [icon=FiArrowRight] optional icon to show, default to arrow right icon. Can opt out with string 'none'
 * @param {string} level 'primary' or 'secondary', defaults to null.
 * @param {string} size default is the standard size. Can also specify 'narrow'
 */

const CallToAction = props => {
    const { href, icon: Icon = FiArrowRight, text, style, target, to } = props;

    let errorStyles = {};

    const finalText = !!text ? text : '\u00A0';

    //If no text
    if (!text) {
        errorStyles = { border: '2px solid red' };
        console.error('CTA text is required');
    }

    //if icon contains a string (not an Icon component), display no icon
    const iconHide = typeof Icon === 'string';

    //Validate presence of either href or to, and not both
    if (!href && !to) {
        errorStyles = { border: '2px solid red' };
        console.error(`Either the 'href' or 'to' prop is required`);
    }

    if (href && to) {
        errorStyles = { border: '2px solid red' };
        console.error(
            `BOTH 'href' and 'to' have been provided, try again with either one`
        );
    }
    const className = getCTAClassNames(props);

    const content = () => {
        return (
            <>
                <span className={styles['text']}>{finalText}</span>
                {!iconHide && (
                    <span className={styles['icon']}>
                        <Icon role="presentation" />
                    </span>
                )}
            </>
        );
    };

    if (to) {
        return (
            <Link
                to={to}
                className={className}
                style={{ ...style, ...errorStyles }}
            >
                {content()}
            </Link>
        );
    }
    return (
        <a
            href={href}
            target={target}
            rel={target === '_blank' ? 'noreferrer' : undefined}
            className={className}
            style={{ ...style, ...errorStyles }}
        >
            {content()}
        </a>
    );
};

export default CallToAction;
